<template>
  <HeaderApp />
  <div class="mt-14"></div>

  <div
    :class="
      'mx-2 mt-14 mb-5 h-full bg-white dark:bg-gray-900 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 no-print ' +
      ($store.getters['isRtl'] ? $store.state.navbar.isSidebarCollapsed
          ? ' md:mr-20 '
          : ' md:mr-60 '
        : $store.state.navbar.isSidebarCollapsed
        ? ' md:ml-20  '
        : ' md:ml-60  ')
    "
  >
    <!-- Header Section -->
    <div class="px-6 py-4 border-b border-gray-200 dark:border-gray-700">
      <h1 class="text-xl font-semibold text-gray-900 dark:text-white">
        {{ $t("returned_invoice") }}
      </h1>
    </div>

    <!-- Form Section -->
    <div
      class="px-6 py-4"
      v-if="
        $store.getters['checkUserAccess']({
          id: '20',
          action: 'add',
        })
      "
    >
      <div class="grid md:grid-cols-2 gap-6">
        <form @submit="AddItem">
          <BaseInput
            v-model="in_id"
            :label="$t('invoice_id')"
            :placeholder="$t('invoice_id')"
            :rules="rules"
            :isError="checkRulesIsError(in_id, 'add', this.rules).isError"
            :errorMsg="checkRulesIsError(in_id, 'add', this.rules).errorMsg"
          />
          <TextAreaInput
            v-model="re_note"
            :label="$t('returned_invoice_note')"
            :placeholder="$t('returned_invoice_note')"
            :rules="rules"
            :isError="checkRulesIsError(re_note, 'add', this.rules).isError"
            :errorMsg="checkRulesIsError(re_note, 'add', this.rules).errorMsg"
          /><BaseInput
            v-model="created_at"
            type="date"
            :label="$t('returned_invoice_date')"
            :placeholder="$t('returned_invoice_date')"
            :rules="[]"
            :isError="checkRulesIsError(created_at, 'add', []).isError"
            :errorMsg="checkRulesIsError(created_at, 'add', []).errorMsg"
          />
          <ButtonInput
            type="button"
            @click="AddItem"
            :label="$t('add')"
            :isLoading="isBtnLoading"
          />
        </form>
      </div>
    </div>
  </div>

  <div
    class="w-full"
    id="printDev"
    v-if="
      $store.getters['checkUserAccess']({
        id: '20',
        action: 'view',
      })
    "
  >
    <InvoiceHeader invoice_type="returned_invoice" v-if="isHide == true" />
    <div class="flex mb-4" v-if="isHide == true">
      <p class="font-semibold text-xl text-textBlack dark:text-textWhite mx-3">
        {{ $t("returned_invoice") }}
      </p>
    </div>

    <!-- Table Container -->
    <div class="px-6 py-4">
      <div
        :class="'bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 overflow-hidden ' +
        (isHide == true
        ? '  '
        : $store.getters['isRtl']
        ? $store.state.navbar.isSidebarCollapsed
          ? ' md:mr-20 '
          : ' md:mr-60 '
        : $store.state.navbar.isSidebarCollapsed
        ? ' md:ml-20  '
        : ' md:ml-60  ')"
      >
        <div class="flex items-center justify-between p-4 border-b border-gray-200 dark:border-gray-700 no-print">
          <div class="flex items-center space-x-4">
            <BaseInput
              :modelValue="$store.state.returns_invoice.search"
              @update:modelValue="handleSearchInput"
              :placeholder="$t('search')"
              :prefixIcon="'fa-solid fa-search'"
              class="w-40 md:w-full"
            />
          </div>
          
          <div class="flex items-center space-x-4">
            <button
              class="inline-flex items-center px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-lg transition-colors duration-200 no-print"
              @click="printReportFunc"
              id="button_print"
            >
              <i class="fa-solid fa-print mr-2"></i>
              {{ $t("print") }}
            </button>
          </div>
        </div>
        <EasyDataTable
          :key="`table-${isDark ? 'dark' : 'light'}`"
          v-model:server-options="serverOptions"
          :headers="headers"
          :items="items"
          :server-items-length="serverItemsLength"
          :loading="isLoadingData"
          :alternating="false"
          :buttons-pagination="true"
          :body-text-direction="$store.getters['isRtl'] ? 'right' : 'left'"
          :hide-footer="isHide"
          :rows-items="[25, 50, 100, serverItemsLength]"
          rows-per-page="10"
          :table-class-name="isDark ? 'modern-dark-table' : ''"
        >
            <template #default="{ column, sortDirection }">
              <div
                :class="`flex items-center space-x-2 ${
                  $store.getters['isRtl'] ? 'justify-end' : 'justify-start'
                }`"
              >
                <span class="font-semibold text-gray-700 dark:text-gray-300">{{
                  column.label
                }}</span>
                <span v-if="column.sortable" class="text-gray-400">
                  <i
                    v-if="sortDirection === 'asc'"
                    class="fa-solid fa-arrow-up text-blue-500"
                  ></i>
                  <i
                    v-else-if="sortDirection === 'desc'"
                    class="fa-solid fa-arrow-down text-blue-500"
                  ></i>
                  <i v-else class="fa-solid fa-arrows-up-down text-gray-400"></i>
                </span>
              </div>
            </template>
            <template #item-actions="item">
              <div class="flex items-center justify-center space-x-2">
                <button
                  @click="showModal(item)"
                  v-if="
                    $store.getters['checkUserAccess']({
                      id: '20',
                      action: 'edit',
                    })
                  "
                  class="inline-flex items-center p-2 text-blue-600 bg-blue-50 hover:bg-blue-100 rounded-lg transition-colors duration-200"
                  :title="$t('edit')"
                >
                  <i class="fa-solid fa-pen text-sm"></i>
                </button>
                <button
                  @click="deleteItem(item.re_id)"
                  v-if="
                    $store.getters['checkUserAccess']({
                      id: '20',
                      action: 'delete',
                    })
                  "
                  class="inline-flex items-center p-2 text-red-600 bg-red-50 hover:bg-red-100 rounded-lg transition-colors duration-200"
                  :title="$t('delete')"
                >
                  <i class="fa-solid fa-trash text-sm"></i>
                </button>
              </div>
            </template>
            <template
              #item-in_id="item"
              v-if="
                $store.getters['checkUserAccess']({
                  id: '19',
                  action: 'detail',
                })
              "
            >
              <a
                class="inline-flex items-center px-2 py-1 text-xs font-medium text-blue-600 bg-blue-100 rounded-md hover:bg-blue-200 transition-colors duration-200"
                :href="'sale-pos/' + item.in_id"
                :title="$t('view_invoice_details')"
                target="_blank"
              >
                <i class="fa-solid fa-external-link-alt mr-1"></i>
                <div class="w-1"></div>
                {{ item.in_id }}
              </a>
            </template>
            <template #loading>
              <div class="flex justify-center items-center py-8">
                <div
                  class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"
                ></div>
                <span class="ml-3 text-gray-600 dark:text-gray-400"
                  >{{ $t("loading") }}...</span
                >
              </div>
            </template>
            <template #item-created_at="item">
              <span class="text-gray-600 dark:text-gray-400 text-sm">
                {{ formatDate(item.created_at) }}
              </span>
            </template>
            <template #empty-message>
              <div class="text-center py-12">
                <i class="fa-solid fa-box-open text-4xl text-gray-400 mb-4"></i>
                <p class="text-gray-500 dark:text-gray-400 text-lg font-medium">
                  {{ $t("no_data_found") }}
                </p>
                <p class="text-gray-400 dark:text-gray-500 text-sm mt-2">
                  {{ $t("try_adjusting_your_search_criteria") }}
                </p>
              </div>
            </template>
            <template
              #pagination="{
                prevPage,
                nextPage,
                isFirstPage,
                isLastPage,
                currentPaginationNumber,
                maxPaginationNumber,
              }"
            >
              <button :disabled="isFirstPage" @click="goToPage(1)">
                <i
                  :class="
                    'fa-sharp fa-solid ' +
                    ($store.getters['isRtl']
                      ? ' fa-angle-double-right'
                      : ' fa-angle-double-left')
                  "
                ></i>
              </button>
              <div class="w-5"></div>
              <button :disabled="isFirstPage" @click="prevPage">
                <i
                  :class="
                    'fa-sharp fa-solid ' +
                    ($store.getters['isRtl']
                      ? ' fa-angle-right'
                      : ' fa-angle-left ')
                  "
                ></i>
              </button>
              <div class="w-5"></div>
              <button
                v-for="page in getVisiblePages(
                  currentPaginationNumber,
                  maxPaginationNumber
                )"
                :key="page"
                @click="goToPage(page)"
                :class="getPageButtonClasses(page, currentPaginationNumber)"
              >
                {{ page }}
              </button>

              <div class="w-5"></div>
              <button :disabled="isLastPage" @click="nextPage">
                <i
                  :class="
                    'fa-sharp fa-solid ' +
                    ($store.getters['isRtl']
                      ? ' fa-angle-left'
                      : ' fa-angle-right')
                  "
                ></i>
              </button>
              <div class="w-5"></div>
              <button
                :disabled="isLastPage"
                @click="goToPage(maxPaginationNumber)"
              >
                <i
                  :class="
                    'fa-sharp fa-solid ' +
                    ($store.getters['isRtl']
                      ? ' fa-angle-double-left'
                      : ' fa-angle-double-right')
                  "
                ></i>
              </button>
            </template>
          </EasyDataTable>
        </div>
      </div>
    </div>

  <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
  <ResultDialog ref="ResultDialog"></ResultDialog>
  <edit-modal ref="editModal">
    <div class="items-center">
      <form @submit="editItem">
        <TextAreaInput
          v-model="current.re_note"
          :label="$t('returned_invoice_note')"
          :placeholder="$t('returned_invoice_note')"
          :rules="rules"
          :isError="
            checkRulesIsError(current.re_note, 'edit', this.rules).isError
          "
          :errorMsg="
            checkRulesIsError(current.re_note, 'edit', this.rules).errorMsg
          "
        /><BaseInput
          v-model="current.created_at"
          type="date"
          :label="$t('returned_invoice_date')"
          :placeholder="$t('returned_invoice_date')"
          :rules="[]"
          :isError="checkRulesIsError(current.created_at, 'edit', []).isError"
          :errorMsg="checkRulesIsError(current.created_at, 'edit', []).errorMsg"
        />
        <center>
          <ButtonInput
            type="button"
            @click="editItem"
            :label="$t('edit')"
            :isLoading="isBtnEditLoading"
          />
        </center>
      </form>
    </div>
  </edit-modal>
</template>
<script>
//import hearder-app
import HeaderApp from "../../components/Navbar/header-app.vue";
import BaseInput from "../../components/Inputs/BaseInput.vue";
import TextAreaInput from "../../components/Inputs/TextAreaInput.vue";
import ButtonInput from "../../components/Inputs/ButtonInput.vue";
import { formatDate } from "../../utils/functions";
import ConfirmDialogue from "../../components/Modals/ConfirmDialogue.vue";
import ResultDialog from "../../components/Modals/ResultDialog.vue";
import EditModal from "../../components/Modals/EditModal.vue";
// eslint-disable-next-line no-unused-vars
import { Header, ServerOptions, Item } from "vue3-easy-data-table";
import InvoiceHeader from "../../components/Navbar/InvoiceHeader.vue";
import "../../assets/css/modern-table.css";
export default {
  name: "ADD_SALE_TYPE",
  components: {
    HeaderApp,
    BaseInput,
    ButtonInput,
    ConfirmDialogue,
    ResultDialog,
    EditModal,
    TextAreaInput,
    InvoiceHeader,
  },
  data() {
    return {
      firstName: "",
      rules: [
        (value) => {
          if (value) return true;

          return this.$t("you_must_fill_this_field");
        },
      ],
      in_id: "",
      re_note: "",
      inputType: "text",
      isSubmited: false,
      isSubmitedEdit: false,
      current: {},
      created_at: "",
      items: [],
      serverItemsLength: 0,
      serverOptions: {
        page: 1,
        rowsPerPage: 12,
      },
      loading: false,
      isHide: false,
    };
  },
  created() {
    if (
      this.$store.getters["checkUserAccess"]({
        id: "20",
        action: "view",
      })
    ) {
      this.getData();
    }
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    getResultDialog(newValue, oldValue) {
      if (newValue) {
        this.$refs.ResultDialog.show({
          message: this.$store.state.returns_invoice.resultMsg,
          okButton: this.$t("done"),
          isSuccess: this.$store.state.returns_invoice.isSuccess,
        });

        // Reset the deleteSuccess state after showing the dialog
        this.$store.commit("returns_invoice/SET_DELETE_SUCCESS", false);
      }
    },
    serverOptions: {
      handler() {
        this.loadFromServer();
      },
      deep: true,
    },
  },

  computed: {
    getResultDialog() {
      return this.$store.state.returns_invoice.isShowResultDialog;
    },

    isDark() {
      return this.$store.state.theme == "dark";
    },
    isLoadingData() {
      return this.$store.state.returns_invoice.isLoadingData;
    },
    isBtnLoading() {
      return this.$store.state.returns_invoice.isBtnLoading;
    },
    isBtnEditLoading() {
      return this.$store.state.returns_invoice.isBtnEditLoading;
    },
    headers() {
      var listHeader = [
        { text: "#", value: "re_id", sortable: true },
        { text: this.$t("invoice_id"), value: "in_id", sortable: true },
        { text: this.$t("invoice_note"), value: "re_note", sortable: true },
        { text: this.$t("admin"), value: "users.name", sortable: true },
        { text: this.$t("created_at"), value: "created_at", sortable: true },
        { text: this.$t("actions"), value: "actions", sortable: false },
      ];
      //remove actions column if isHide is true
      if (this.isHide == true) {
        listHeader.pop();
      }
      return listHeader;
    },
  },
  mounted() {
    // First load when the component is mounted
    this.loadFromServer();
  },
  methods: {
    handleSearchInput(value) {
      this.$store.commit('returns_invoice/SET_SEARCH', value);
      this.loadFromServer();
      this.serverOptions.page = 1;
    },
    printReportFunc() {
      this.isHide = true;
      //wait 1 second
      setTimeout(() => {
        var printContents = document.getElementById("printDev").innerHTML;

        // Replace the body's innerHTML with the print contents
        document.body.innerHTML = printContents;
        var isRtl = this.$store.getters["isRtl"];
        // Set direction based on the parameter
        if (isRtl) {
          document.body.style.direction = "rtl";
        } else {
          document.body.style.direction = "ltr";
        }

        // Print the content
        window.print();  // Adjust the timeout as needed
        //reload page
      }, 100);
      //print element id invoice_print
    },
    getVisiblePages(currentPage, totalPages) {
      const numVisibleButtons = 3; // Adjust this number based on your design preference
      const pages = [];

      // Display pages 1 to numVisibleButtons (e.g., 1, 2, 3)
      if (currentPage <= Math.floor(numVisibleButtons / 2) + 1) {
        for (let i = 1; i <= Math.min(totalPages, numVisibleButtons); i++) {
          pages.push(i);
        }
      }
      // Display pages around the current page (e.g., 1, ..., 10, ..., 20)
      else {
        const startPage = Math.max(
          1,
          currentPage - Math.floor(numVisibleButtons / 2)
        );
        const endPage = Math.min(totalPages, startPage + numVisibleButtons - 1);

        for (let i = startPage; i <= endPage; i++) {
          pages.push(i);
        }
      }

      return pages;
    },

    // Function to get Tailwind CSS classes for each page button
    getPageButtonClasses(page, currentPage) {
      return {
        "bg-blue-500 text-white": page === currentPage,
        "bg-gray-300 text-gray-700 hover:bg-gray-400": page !== currentPage,
        "p-2 rounded-md mx-1": true, // Adjust padding and rounding based on your design
      };
    },

    goToPage(page) {
      // Implement your logic to update the current page
      //update page
      this.serverOptions.page = page;
      this.loadFromServer();
    },
    async loadFromServer() {
      this.loading = true;

      var tempObj = { ...this.serverOptions };
      //add new field to object search
      tempObj.search = this.$store.state.returns_invoice.search;
      const res = await this.$store.dispatch(
        "returns_invoice/getItems",
        tempObj
      );

      this.items = res.data.data;
      this.serverItemsLength = res.data.total;
      this.loading = false;
    },
    routeTo(href) {
      //go href and refresh page
      this.$store.commit("edit_sale/SET_EDIT_SALE_CLEAR", {});
      this.$router.push({ path: href }).catch(() => {});
      //clear edit_sale state module
    },
    formatDate(date) {
      return formatDate(date);
    },
    getData() {
      //this.$store.dispatch("returns_invoice/getItems");
    },
    async AddItem() {
      //check form validation
      if (this.$store.state.returns_invoice.isBtnLoading) return;

      this.isSubmited = true;
      if (
        this.checkRulesIsError(this.in_id, "add", this.rules).isError ||
        this.checkRulesIsError(this.re_note, "add", this.rules).isError
      ) {
        return;
      }
      this.$store.state.returns_invoice.isBtnLoading = true;
      var res = await this.$store.dispatch("returns_invoice/addNewItem", {
        in_id: this.in_id,
        re_note: this.re_note,
        created_at: this.created_at,
      });
      if (res.status == 200) {
        this.in_id = "";
        this.re_note = "";
        this.isSubmited = false;
        var tempObj = { ...this.serverOptions };
        const res = await this.$store.dispatch(
          "returns_invoice/getItems",
          tempObj
        );

        this.items = res.data.data;
        this.serverItemsLength = res.data.total;
        this.loading = false;
        this.$store.state.returns_invoice.isBtnLoading = false;
      }
    },
    checkRulesIsError(value, type, rules) {
      var isError = false;
      var errorMsg = "";
      if (type == "add") {
        if (this.isSubmited == false)
          return {
            isError: false,
            errorMsg: "",
          };
      }
      if (type == "edit") {
        if (this.isSubmitedEdit == false)
          return {
            isError: false,
            errorMsg: "",
          };
      }

      for (const rule of rules) {
        if (rule(value) !== true) {
          isError = true;
          errorMsg = rule(value);
          // Stop the loop
          break;
        } else {
          isError = false;
          errorMsg = "";
        }
      }

      return {
        isError: isError,
        errorMsg: errorMsg,
      };
    },
    async deleteItem(id) {
      const ok = await this.$refs.confirmDialogue.show({
        message: this.$t("are_you_sure_remove_this_item") + id,
        okButton: this.$t("delete"),
      });
      if (ok) {
        //remove item from items array when re_id is equal to id
        this.items = this.items.filter((item) => item.re_id !== id);
        await this.$store.dispatch("returns_invoice/deleteItem", id);
        this.loadFromServer();
      }
    },
    //edit
    async showModal(item) {
      this.current = item;
      this.current.created_at = this.current.created_at
        .toString()
        .split("T")[0];
      await this.$refs.editModal.show();
    },
    async editItem(e) {
      e.preventDefault();
      this.isSubmitedEdit = true;
      if (
        this.checkRulesIsError(this.current.re_id, "edit", this.rules)
          .isError ||
        this.checkRulesIsError(this.current.re_note, "edit", this.rules).isError
      ) {
        return;
      }
      this.$store.state.returns_invoice.isBtnEditLoading = true;
      var res = await this.$store.dispatch("returns_invoice/editItem", {
        re_id: this.current.re_id,
        re_note: this.current.re_note,
        created_at: this.current.created_at,
      });

      this.isSubmitedEdit = false;
      this.$store.state.returns_invoice.isBtnEditLoading = false;
      if (res.status == 200) {
        this.$refs.editModal.hide();
        this.loadFromServer();
      }
    },
  },
};
</script>
